class FacetAccordion {
  constructor(container) {
    this.container = container;
    this.detailsList = Array.from(container.querySelectorAll(':scope > .mobile-facets__details'));
    this.init();
  }

  init() {
    this.detailsList.forEach((details) => {
      const summary = details.querySelector(':scope > summary.mobile-facets__summary');
      const submenu = details.querySelector(':scope > .mobile-facets__submenu');
      if (!summary || !submenu || summary.dataset.accordionInit) return;
      summary.dataset.accordionInit = 'true';

      // Force-set transition + initial closed/open state via inline style
      submenu.style.overflow = 'hidden';
      submenu.style.transition = 'max-height 0.38s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.3s ease';

      if (details.hasAttribute('open')) {
        submenu.style.maxHeight = 'none';
        submenu.style.opacity = '1';
      } else {
        submenu.style.maxHeight = '0px';
        submenu.style.opacity = '0';
      }

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggle(details, submenu);
      });
    });
  }

  toggle(details, submenu) {
    if (details.hasAttribute('open')) {
      this.close(details, submenu);
    } else {
      this.detailsList.forEach((other) => {
        if (other !== details && other.hasAttribute('open')) {
          const otherSubmenu = other.querySelector(':scope > .mobile-facets__submenu');
          this.close(other, otherSubmenu);
        }
      });
      this.open(details, submenu);
    }
  }

  open(details, submenu) {
    details.setAttribute('open', '');

    const targetHeight = submenu.scrollHeight;
    submenu.style.maxHeight = '0px';
    submenu.style.opacity = '0';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        submenu.style.maxHeight = targetHeight + 'px';
        submenu.style.opacity = '1';
      });
    });

    submenu.addEventListener(
      'transitionend',
      function handler(e) {
        if (e.propertyName !== 'max-height') return;
        submenu.style.maxHeight = 'none';
        submenu.removeEventListener('transitionend', handler);
      },
      { once: true }
    );
  }

  close(details, submenu) {
    const currentHeight = submenu.scrollHeight;
    submenu.style.maxHeight = currentHeight + 'px';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        submenu.style.maxHeight = '0px';
        submenu.style.opacity = '0';
      });
    });

    submenu.addEventListener(
      'transitionend',
      function handler(e) {
        if (e.propertyName !== 'max-height') return;
        details.removeAttribute('open');
        submenu.removeEventListener('transitionend', handler);
      },
      { once: true }
    );
  }
}

function initFacetAccordions() {
  document.querySelectorAll('#FacetsWrapperMobile').forEach((container) => {
    new FacetAccordion(container);
  });
}

document.addEventListener('DOMContentLoaded', initFacetAccordions);

document.querySelectorAll('.facets-container').forEach((el) => {
  new MutationObserver(initFacetAccordions).observe(el, { childList: true, subtree: true });
});